import { useMemo } from "react";

import {
  getTotalSweepEntries,
  handleAssetUrl,
  handleChooseGameModalBtnClick,
  handlePrizeVaultModalBtnClick,
} from "../../utils";
import { ArcadeIntroModal } from "../arcade-intro-modal/arcade-intro-modal.component";

const LOWEST_PROGRESS_VISIBLE_DESKTOP = -92;
const LOWEST_PROGRESS_VISIBLE_MOBILE = -86;

function calcProgress(
  cheapestPrize: number,
  points: number,
  isMobile: boolean
): number {
  const fraction = 100 / cheapestPrize;
  const pointsLeft = cheapestPrize - points;
  const offset = -Math.round(pointsLeft * fraction);
  const lowestProgress = isMobile
    ? LOWEST_PROGRESS_VISIBLE_MOBILE
    : LOWEST_PROGRESS_VISIBLE_DESKTOP;

  return offset < lowestProgress ? lowestProgress : offset;
}

interface Props {
  allTimeEntries: number;
  extraEntries: number;
  redeemedEntries: number;
  sessionEntries: number;
}

export function ArcadeHeader({
  allTimeEntries,
  extraEntries,
  redeemedEntries,
  sessionEntries,
}: Props) {
  const allTimePoints = useMemo(() => {
    const submission = window.theme.Sweepstake.prototype.retrieveSubmission();
    return (
      allTimeEntries -
      redeemedEntries +
      extraEntries +
      getTotalSweepEntries(submission?.data, [
        "submissionCount",
        "quizExtraEntries",
      ])
    );
  }, [allTimeEntries, redeemedEntries, extraEntries]);

  const cheapestPrize = window.FKL.productLowestPoints;

  return (
    <>
      <ArcadeIntroModal />
      <div className="arcade-black--header">
        <div className="arcade-black-header--content">
          <div className="arcade-black-header--buttons">
            <button onClick={handlePrizeVaultModalBtnClick}>
              <img
                src={handleAssetUrl("arcade-gift-icon.svg")}
                alt="prize"
              />
              <span>prize vault</span>
            </button>
            <button onClick={handleChooseGameModalBtnClick}>
              <img
                src={handleAssetUrl("arcade-play-icon.svg")}
                alt="play"
              />
              <span>more games</span>
            </button>
          </div>
          <div className="arcade-black-header--progress-bar">
            <span className="arcade-black-header--gradient-title">
              ARCADE
            </span>
            {cheapestPrize >= allTimePoints && (
              <>
                <div className="arcade-black-header-progress-bar">
                  <div
                    className="arcade-black-header-progress desktop-bar"
                    style={{
                      transform: `translateX(${calcProgress(
                        cheapestPrize,
                        allTimePoints,
                        false
                      )}%)`,
                    }}
                  >
                    {allTimePoints}
                  </div>
                  <div
                    className="arcade-black-header-progress mobile-bar"
                    style={{
                      transform: `translateX(${calcProgress(
                        cheapestPrize,
                        allTimePoints,
                        true
                      )}%)`,
                    }}
                  >
                    {""}
                  </div>
                </div>
                <div className="arcade-black-header-prize-text">
                  Unlock your first prize!
                </div>
              </>
            )}
            {cheapestPrize < allTimePoints && (
              <div className="arcade-black-header-prize-text">
                Redeem your points for prizes!
              </div>
            )}
          </div>
          <div className="arcade-black-header--points-tracker">
            <div className="arcade-black-header-total-title">point totals</div>
            <div className="arcade-black-header-total-points">
              all time: {allTimePoints.toLocaleString()}
            </div>
            <div className="arcade-black-header-current-points">
              this session: {sessionEntries.toLocaleString()}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
